// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_g6-a";
export var fulfillmentFormRail = "_g6-9";
export var headerTitleRow = "_g6-c";
export var orderDetailsWrapper = "_g6-7";
export var orderLinkTrigger = "_g6-2";
export var paymentInformationGrid = "_g6-h";
export var paymentSummaryColumn = "_g6-i";
export var shipmentContainer = "_g6-b";
export var shipmentDetailsMainPane = "_g6-8";
export var shipmentNavigationCard = "_g6-5";
export var shipmentNavigationRail = "_g6-3";
export var shipmentNavigationRailHeader = "_g6-4";
export var shipmentSummaryFact = "_g6-e";
export var shipmentSummaryGrid = "_g6-d";
export var shipmentSummaryMetadataRow = "_g6-f";
export var shipmentSummaryTags = "_g6-g";
export var shipmentWorkspace = "_g6-0";
export var shipmentWorkspaceContent = "_g6-6";
export var shipmentWorkspaceHeader = "_g6-1";